(function () {
  // Homepage
  document.querySelector(`.gh-burger`).addEventListener("click", function () {
    const body = document.querySelector("body");

    if (body.classList.contains("gh-head-open")) {
      body.classList.remove("gh-head-open");
    } else {
      body.classList.add("gh-head-open");
    }
  });

  // Post page
  var images = document.querySelectorAll(".kg-gallery-image img");

  images.forEach(function (image) {
    var container = image.closest(".kg-gallery-image");
    var width = image.attributes.width.value;
    var height = image.attributes.height.value;
    var ratio = width / height;
    container.style.flex = ratio + " 1 0%";
  });

  // Open links to external domains found in a post in a new tab
  document.querySelectorAll(".post-full-content a").forEach((link) => {
    const a = new RegExp("/" + window.location.host + "/");

    if (!a.test(link.href)) {
      link.setAttribute("rel", "noopener noreferrer nofollow");
      link.setAttribute("target", "_blank");
    }
  });
})();
